import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';

import router from './router';
import store from './store';
import VueToast from 'vue-toast-notification';
import VueApollo from 'vue-apollo';
import {apolloProvider} from '@/plugins/apollo';
import ShowGqlError from '@/plugins/show-gql-error';
import VueMoment from 'vue-moment';
import './plugins/filters';

// Css styles
import './assets/styles/styles.scss';
import "./assets/styles/wysiwyg.scss";
import 'vue-toast-notification/dist/theme-sugar.css';
import {i18n} from '@/plugins/i18n';

// install the vue plugin
Vue.use(VueApollo);
Vue.use(VueToast, {
	position: 'bottom-right',
	duration: 20000
});


const moment = require('moment');
require('moment/locale/ru');
moment.updateLocale('ru', {months: [...i18n.t('date.months.full')]});
Vue.use(VueMoment, {
	moment
});

Vue.config.productionTip = false;

Vue.use(ShowGqlError, {
	toast: Vue.prototype.$toast,
	i18n
});

Vue.config.ignoredElements = ["youtube-embed"];


new Vue({
	router,
	store,
	vuetify,
	apolloProvider,
	i18n,
	render: (h) => h(App)
}).$mount('#app');
